export const environment = {
    baseUrl: 'https://api-tiras-corte.itsoft.mx/api',
    encryptionKey: '4e6FEsr3#21_Ofuscada123!',
};


